import React , {useRef} from 'react'
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import OtherUserProfile from '../OtherUserProfile';

function FindARoomate() {
	const inputEl = useRef(null);
  const onSearch = () => {
    // `current` points to the mounted text input element
    console.log(inputEl.current.input.value);
  };
  return (
  <>
    <div className='container'>
	<br/>
	<Input size="large" ref={inputEl} placeholder="Search name or username " id='serch' prefix={<a href='#' onClick={onSearch}><SearchOutlined /></a>} 
	style={{ width: '100%',height: 60, border: '1px solid #ADADAD', borderRadius: 10, display:'flex', alignItems:'center' }}
	bordered={false}
	/>
	<br/><br/>
	<p class='subtext'>Your prefered locations are set to Lekki and Yaba</p>
	
	<p class='green-text subtext-3'>Change prefered locations</p>
	<br/>
	<p class='subheader-3'>Users with your prefered location</p>
	<br/>
	<div class='users-from-search'>
			<OtherUserProfile />
            <OtherUserProfile />
            <OtherUserProfile />
            <OtherUserProfile />
            <OtherUserProfile />
            <OtherUserProfile />
            <OtherUserProfile />
	</div>
      
  </div>
  <br/><br/><br/><br/></>
  )
}

export default FindARoomate